<template>
  <div>
    <div class="field">
      <label for="count">{{ $t('COUNT', { thing: $tc('ENTRY', 2) }) }}</label>
      <input id="count" type="number" :placeholder="10" v-model.number="v" />
    </div>
  </div>
</template>

<script>
// @flow
import Vue from 'vue'

export default {
  name: 'last-edit-options',

  props: {
    count: {
      type: Number,
      default: () => 10
    }
  },

  data() {
    return {
      v: this.count
    }
  },

  watch: {
    v(newCount) {
      this.$emit('update', { count: newCount || 10 })
    }
  }
}
</script>
